import { render, staticRenderFns } from "./ImgChooser.vue?vue&type=template&id=d1a53196"
import script from "./ImgChooser.vue?vue&type=script&lang=js"
export * from "./ImgChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports